export default [
	{
		path: '/purchase/service/:id',
		name: 'PurchaseService',
		component: () => import('@/views/purchase/service.vue'),
		meta: { title: '购买服务' }
	},
	{
		path: '/purchase/success/:id',
		name: 'PurchaseSuccess',
		component: () => import('@/views/purchase/success.vue'),
		meta: { title: '购买服务' }
	},
	{
		path: '/agreement/:id',
		name: 'Agreement',
		component: () => import('@/views/purchase/agreement.vue'),
		meta: { title: '抗体检测知情同意书' }
	}
]
